import React from "react";
import Loader from "./Loader.tsx";

const Layout = ({ children, loading = false }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "calc(100vh - 75)",
        position: "relative",
      }}
    >
      <Loader isLoading={loading} />
      <div style={{ flex: "1 0 auto", paddingBottom: 88 }}>{children}</div>
    </div>
  );
};

export default Layout;
